/**
 * Verify assertion and throw error if it is false
 * @param condition - This is the condition to be evaluated
 * @param message - This is the message to be shown if the condition is false
 */
export function assert(condition: boolean, message: string) {
  if (!condition) {
    throw new Error(message || "Assertion failed");
  }
}

/**
 * Exhaustive switch check that throws at runtime.
 * Use in switch defaults where reaching the branch is a programming error.
 */
export function assertNeverOrThrow(value: never, message?: string): never {
  throw new Error(message ?? `Unhandled case: ${value}`);
}

/**
 * Exhaustive switch check that does NOT throw.
 * Use in switch defaults where unhandled cases are expected
 * (e.g. returning a fallback value after the check).
 */
export function assertNever(_value: never): void {
  return;
}
